import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "row px-4 py-2 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 offset-lg-1 col-lg-10 mb-1 row g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Information")
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_5 = {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}
const _hoisted_6 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" First Name ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_10 = { class: "form-group col-4 col-lg-2 pe-lg-2" }
const _hoisted_11 = { for: "referral-middle-initial" }
const _hoisted_12 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_13 = ["maxlength", "placeholder"]
const _hoisted_14 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_15 = {
  id: "Referral_Last_Name_Label",
  for: "referral-last-name"
}
const _hoisted_16 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Last Name ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_20 = { class: "form-group col-4 col-lg-2 pe-lg-2" }
const _hoisted_21 = { for: "referral-suffix" }
const _hoisted_22 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Suffix ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_25 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_26 = {
  for: "date-of-birth",
  id: "Referral_Date_Of_Birth_Label"
}
const _hoisted_27 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Date of Birth ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_30 = { class: "input-group date datepickerInput" }
const _hoisted_31 = ["value", "on-change"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_33 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_34 = { class: "form-group col-12 col-lg-2 pe-lg-2" }
const _hoisted_35 = {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}
const _hoisted_36 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Sex ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Sex", -1 /* HOISTED */)
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_42 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Identity_Label",
  for: "referral-gender-identity"
}, " Sex Identity ", -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Sex Identity", -1 /* HOISTED */)
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "form-group col-12 col-lg-3 pe-lg-2"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Other_Gender_Identity_Label",
  for: "referral-other-gender-identity"
}, [
  /*#__PURE__*/_createTextVNode(" Please specify "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_49 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Sexual_Orientation_Label",
  for: "referral_sexual_orientation"
}, " Sexual Orientation ", -1 /* HOISTED */)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Sexual Orientation", -1 /* HOISTED */)
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 0,
  class: "form-group col-12 col-lg-3 pe-lg-2"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Other_Sexual_Orientation_Label",
  for: "referral-other-sexual-orientation"
}, [
  /*#__PURE__*/_createTextVNode(" Please specify "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_55 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_56 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_57 = { for: "referral-social-security-number" }
const _hoisted_58 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Social Security Number ")
const _hoisted_60 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_61 = { class: "form-group col-4 col-lg-2 pe-lg-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "referral-veteran" }, " Veteran ", -1 /* HOISTED */)
const _hoisted_63 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_64 = { class: "input-group-text form-check custom-checkbox" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-3",
  for: "veteran"
}, null, -1 /* HOISTED */)
const _hoisted_66 = { class: "flex-shrink-1 flex-grow-1" }
const _hoisted_67 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Occupation ", -1 /* HOISTED */)
const _hoisted_69 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Occupation Industry", -1 /* HOISTED */)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_72 = {
  key: 3,
  class: "form-group col-12 col-lg-4 pe-lg-2"
}
const _hoisted_73 = { for: "referral-mobile-number" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Primary Phone Number ")
const _hoisted_75 = { class: "fas fa-question-circle" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_81 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_82 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_83 = {
  key: 4,
  class: "form-group col-12 col-lg-4 pe-lg-2"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-phone" }, " Alternate Phone Number ", -1 /* HOISTED */)
const _hoisted_85 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { for: "referral-email" }, " Email ", -1 /* HOISTED */)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_88 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Agency_Branch_Label",
  for: "agency-location-id"
}, [
  /*#__PURE__*/_createTextVNode(" Agency Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Branch", -1 /* HOISTED */)
const _hoisted_91 = ["value"]
const _hoisted_92 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_93 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { for: "referral-marital-status" }, " Marital Status ", -1 /* HOISTED */)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Marital Status", -1 /* HOISTED */)
const _hoisted_96 = ["value"]
const _hoisted_97 = {
  key: 5,
  class: "form-group col-12 col-lg-4 pe-lg-2"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { for: "referral-ethnicity" }, [
  /*#__PURE__*/_createTextVNode(" Ethnicity "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Ethnicity", -1 /* HOISTED */)
const _hoisted_101 = ["value"]
const _hoisted_102 = { class: "form-check custom-checkbox pt-1" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "decline-ethnicity"
}, "Declines to Specify", -1 /* HOISTED */)
const _hoisted_104 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  key: 1,
  class: "form-group col-12 col-lg-6 pe-lg-2 race-section"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { for: "referral-race" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1000"),
  /*#__PURE__*/_createTextVNode(" Race "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_111 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_112 = { key: 2 }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = {
  key: 3,
  class: "form-group col-12 col-lg-6 pe-lg-2"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { for: "ethnicityHospice" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A1000"),
  /*#__PURE__*/_createTextVNode(" Ethnicity "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_117 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_119 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { for: "referral-race" }, " Race ", -1 /* HOISTED */)
const _hoisted_121 = { class: "form-check custom-checkbox pt-1" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "decline-race"
}, "Declines to Specify", -1 /* HOISTED */)
const _hoisted_123 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " More Granular Race ", -1 /* HOISTED */)
const _hoisted_125 = { class: "form-group col-12 col-lg-2 pe-lg-2" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", { for: "tribeIdentification" }, " Patient identifies with a tribe ", -1 /* HOISTED */)
const _hoisted_127 = { class: "col-12 d-flex px-0" }
const _hoisted_128 = { class: "custom-control custom-radio custom-control-inline pe-lg-2" }
const _hoisted_129 = ["disabled"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "yesTribe"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_131 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "noTribe"
}, " No ", -1 /* HOISTED */)
const _hoisted_134 = { class: "custom-control custom-checkbox pt-1" }
const _hoisted_135 = ["checked"]
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "decline-tribe"
}, "Declines to Specify", -1 /* HOISTED */)
const _hoisted_137 = {
  key: 0,
  class: "form-group col-12 col-lg-2 pe-lg-2"
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { for: "referral-tribal-affiliation" }, [
  /*#__PURE__*/_createTextVNode(" Tribal Affiliation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Tribal Affiliation", -1 /* HOISTED */)
const _hoisted_140 = ["value"]
const _hoisted_141 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_142 = {
  key: 1,
  class: "form-group col-12 col-lg-2 pt-1 pe-lg-2"
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "pt-2" }, null, -1 /* HOISTED */)
const _hoisted_144 = {
  key: 2,
  class: "form-group col-12 col-lg-2 ps-2 pt-1 pe-lg-2"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", { class: "pt-2 mt-1" }, null, -1 /* HOISTED */)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Primary Address")
  ])
], -1 /* HOISTED */)
const _hoisted_147 = { key: 8 }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_149 = [
  _hoisted_148
]
const _hoisted_150 = { class: "col-12 d-flex align-items-center" }
const _hoisted_151 = { class: "me-2 ai-validate-address-btn" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1 /* HOISTED */)
const _hoisted_153 = {
  key: 1,
  class: "text-success fw-bold"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1 /* HOISTED */)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("span", null, " Address Validated ", -1 /* HOISTED */)
const _hoisted_156 = [
  _hoisted_154,
  _hoisted_155
]
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Visit Address")
  ])
], -1 /* HOISTED */)
const _hoisted_158 = { key: 10 }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = { class: "col-12 form-group d-flex" }
const _hoisted_162 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "visit-same-primary-address"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Primary Address")
], -1 /* HOISTED */)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Mailing Address")
  ])
], -1 /* HOISTED */)
const _hoisted_165 = { key: 12 }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_167 = [
  _hoisted_166
]
const _hoisted_168 = { class: "col-12 form-group d-flex" }
const _hoisted_169 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "mailing-same-primary-address"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Primary Address")
], -1 /* HOISTED */)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Previous Address")
  ])
], -1 /* HOISTED */)
const _hoisted_172 = { key: 0 }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_174 = [
  _hoisted_173
]
const _hoisted_175 = { class: "col-12 form-group d-flex" }
const _hoisted_176 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "previous-same-primary-address"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Has Previous Address")
], -1 /* HOISTED */)
const _hoisted_178 = { class: "row" }
const _hoisted_179 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Cahps_Label",
  for: "referral-Cahps"
}, " CAHPS Survey ", -1 /* HOISTED */)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Receive CAHPS Survey", -1 /* HOISTED */)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "No Publicity", -1 /* HOISTED */)
const _hoisted_183 = [
  _hoisted_181,
  _hoisted_182
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_MultiSelectFilter = _resolveComponent("MultiSelectFilter")!
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    id: "Demographic_Information",
    title: "Demographic Information",
    type: `${_ctx.isHisSection ? 'his-section' : 'default-section'}`,
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "A0500A"))
                : _createCommentVNode("v-if", true),
              _hoisted_7,
              _hoisted_8
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "Referral_First_Name",
              name: "referral-first-name",
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.firstName.$error ? '' : 'field-invalid'}`]),
              maxlength: "50",
              type: "text",
              placeholder: "Enter First Name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.firstName) = $event)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.firstName.$touch && _ctx.v$.referral.firstName.$touch(...args)))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.firstName]
            ]),
            (_ctx.v$.referral.firstName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "First Name is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "A0500B"))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(_ctx.middleLabel), 1 /* TEXT */)
            ]),
            _withDirectives(_createElementVNode("input", {
              name: "referral-middle-initial",
              class: "form-control",
              maxlength: _ctx.isApplicationPalliative ? 100 : 1,
              type: "text",
              placeholder: _ctx.isApplicationPalliative ? 'Enter Middle Name' : 'Enter M.I.',
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.middleName) = $event))
            }, null, 8 /* PROPS */, _hoisted_13), [
              [_vModelText, _ctx.middleName]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "A0500C"))
                : _createCommentVNode("v-if", true),
              _hoisted_17,
              _hoisted_18
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "Referral_Last_Name",
              name: "referral-last-name",
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.lastName.$error ? '' : 'field-invalid'}`]),
              maxlength: "50",
              placeholder: "Enter Last Name",
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.lastName) = $event)),
              onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.lastName.$touch && _ctx.v$.referral.lastName.$touch(...args)))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.lastName]
            ]),
            (_ctx.v$.referral.lastName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Last Name is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "A0500D"))
                : _createCommentVNode("v-if", true),
              _hoisted_23
            ]),
            _withDirectives(_createElementVNode("input", {
              name: "referral-suffix",
              class: "form-control",
              maxlength: "4",
              type: "text",
              placeholder: "Enter Suffix",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.suffix) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.suffix]
            ])
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "A0900"))
                : _createCommentVNode("v-if", true),
              _hoisted_28,
              _hoisted_29
            ]),
            _createVNode(_component_DatePicker, { getDate: _ctx.getDate }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("input", {
                    name: "dateOfBirth",
                    id: "Referral_Date_Of_Birth",
                    type: "text",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.referral.dateOfBirth.$error ? '' : 'field-invalid'}`]),
                    placeholder: "MM/DD/YYYY",
                    value: _ctx.formatDateInput(_ctx.referral.dateOfBirth),
                    "on-change": (e) => _ctx.getDate(e.target.value, e.target.name),
                    autocomplete: "off",
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.dateOfBirth.$touch && _ctx.v$.referral.dateOfBirth.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_31),
                  _hoisted_32,
                  (_ctx.v$.referral.dateOfBirth.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Date of Birth is required."))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("label", _hoisted_35, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "A0800"))
                : _createCommentVNode("v-if", true),
              _hoisted_37,
              _hoisted_38
            ]),
            _withDirectives(_createElementVNode("select", {
              id: "Referral_Gender",
              class: _normalizeClass(["form-select", `${!_ctx.v$.referral.gender.$error ? '' : 'field-invalid'}`]),
              name: "referral-gender",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.gender) = $event)),
              onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.gender.$touch && _ctx.v$.referral.gender.$touch(...args)))
            }, [
              _hoisted_39,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Genders, (value) => {
                return _withDirectives((_openBlock(), _createElementBlock("option", {
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_40)), [
                  [_vShow, !(!_ctx.isApplicationPalliative && value.value == _ctx.genderUnknownValue)]
                ])
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.gender]
            ]),
            (_ctx.v$.referral.gender.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Sex is required."))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("select", {
                    id: "Referral_Gender_Identity",
                    class: "form-select",
                    name: "referral-gender-identity",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.genderIdentity) = $event))
                  }, [
                    _hoisted_44,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GenderIdentities, ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_45))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.referral.genderIdentity]
                  ])
                ]),
                (_ctx.referral.genderIdentity === 6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _hoisted_47,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_Other_Gender_Identity",
                        name: "referral-other-gender-identity",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.referral.otherGenderIdentity.$error ? '' : 'field-invalid'}`]),
                        maxlength: "255",
                        type: "text",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.otherGenderIdentity) = $event)),
                        onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.otherGenderIdentity.$touch && _ctx.v$.referral.otherGenderIdentity.$touch(...args)))
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelText, _ctx.referral.otherGenderIdentity]
                      ]),
                      (_ctx.v$.referral.otherGenderIdentity.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "OtherGenderIdentity is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("select", {
                    id: "Referral_Sexual_Orientation",
                    class: "form-select",
                    name: "referral_sexual_orientation",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.sexualOrientation) = $event))
                  }, [
                    _hoisted_51,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SexualOrientation, ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_52))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.referral.sexualOrientation]
                  ])
                ]),
                (_ctx.referral.sexualOrientation === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_Other_Sexual_Orientation",
                        name: "referral-other-sexual-orientation",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.referral.otherSexualOrientation.$error ? '' : 'field-invalid'}`]),
                        maxlength: "255",
                        type: "text",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.otherSexualOrientation) = $event)),
                        onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.otherSexualOrientation.$touch && _ctx.v$.referral.otherSexualOrientation.$touch(...args)))
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelText, _ctx.referral.otherSexualOrientation]
                      ]),
                      (_ctx.v$.referral.otherSexualOrientation.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, "OtherSexualOrientation is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("label", _hoisted_57, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_58, "A0600A"))
                : _createCommentVNode("v-if", true),
              _hoisted_59
            ]),
            _withDirectives(_createElementVNode("input", {
              name: "referral-social-security-number",
              maxlength: "9",
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.socialSecurityNumber.$error ? '' : 'field-invalid'}`]),
              type: "text",
              placeholder: "Enter SSN",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.socialSecurityNumber) = $event)),
              onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.socialSecurityNumber.$touch && _ctx.v$.referral.socialSecurityNumber.$touch(...args)))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.socialSecurityNumber],
              [_directive_number_only]
            ]),
            (_ctx.v$.referral.socialSecurityNumber.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.v$.referral.socialSecurityNumber.$errors[0].$message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "",
                  id: "veteran",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isVeteranSelected) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.isVeteranSelected]
                ]),
                _hoisted_65
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_MultiSelectDropdown, {
                  disabled: !_ctx.isVeteranSelected,
                  options: _ctx.veteranOptions,
                  "selected-items": _ctx.referral.veteran,
                  onSelectedItemsUpdated: _ctx.selectedItemsUpdated
                }, null, 8 /* PROPS */, ["disabled", "options", "selected-items", "onSelectedItemsUpdated"])
              ])
            ])
          ]),
          (_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getOccupationList,
                    value: _ctx.occupation,
                    onValueChanged: _ctx.occupationChanged,
                    "open-on-focus": true,
                    "must-select-value": true,
                    placeholder: "Select Occupation",
                    closeOnOutsideClick: true
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getIndustryList,
                    value: _ctx.industry,
                    onValueChanged: _ctx.industryChanged,
                    "show-all-by-default": true,
                    "open-on-focus": true,
                    "must-select-value": true,
                    placeholder: "Select Occupation Industry",
                    closeOnOutsideClick: true
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _hoisted_71,
          (_ctx.arePhoneNumbersAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createElementVNode("label", _hoisted_73, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("i", _hoisted_75, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, { title: _ctx.tooltip }]
                  ]),
                  _hoisted_76
                ]),
                _withDirectives(_createVNode(_component_PhoneNumber, {
                  "enable-country": true,
                  value: _ctx.primaryNumber,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.primaryNumber) = $event)),
                  extension: _ctx.primaryExtension,
                  "onUpdate:extension": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.primaryExtension) = $event)),
                  type: _ctx.primaryType,
                  "onUpdate:type": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.primaryType) = $event)),
                  country: _ctx.primaryCountry,
                  "onUpdate:country": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.primaryCountry) = $event)),
                  "phone-type-options": _ctx.phoneNumberTypeOptionsConfig,
                  onBlurredInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.referral.phoneNumbers.$touch())),
                  class: _normalizeClass(`${
                                !_ctx.v$.referral.phoneNumbers?.phoneNumber.$invalid ||
                                !_ctx.v$.referral.phoneNumbers?.phoneType.$invalid
                                    ? ''
                                    : 'field-invalid'
                            }`)
                }, null, 8 /* PROPS */, ["value", "extension", "type", "country", "phone-type-options", "class"]), [
                  [_directive_number_only]
                ]),
                (_ctx.v$.referral.phoneNumbers?.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                      (
                                    _ctx.v$.referral.phoneNumbers?.phoneNumber.$invalid &&
                                    _ctx.v$.referral.phoneNumbers?.phoneType.$invalid
                                )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_78, "Phone Number and Phone Type is required."))
                        : (_ctx.v$.referral.phoneNumbers?.phoneNumber.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                              (_ctx.v$.referral.phoneNumbers?.$errors[0].$message == 'Value is required')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, "Phone Number is required."))
                                : (_openBlock(), _createElementBlock("span", _hoisted_81, "10 Digit phone is required."))
                            ]))
                          : (_ctx.v$.referral.phoneNumbers?.phoneType.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, "Phone Type is required."))
                            : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.arePhoneNumbersAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _hoisted_84,
                _withDirectives(_createVNode(_component_PhoneNumber, {
                  "enable-country": true,
                  value: _ctx.alternateNumber,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.alternateNumber) = $event)),
                  extension: _ctx.alternateExtension,
                  "onUpdate:extension": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.alternateExtension) = $event)),
                  type: _ctx.alternateType,
                  "onUpdate:type": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.alternateType) = $event)),
                  country: _ctx.alternateCountry,
                  "onUpdate:country": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.alternateCountry) = $event)),
                  "phone-type-options": _ctx.phoneNumberTypeOptionsConfig
                }, null, 8 /* PROPS */, ["value", "extension", "type", "country", "phone-type-options"]), [
                  [_directive_number_only]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _withDirectives(_createElementVNode("input", {
              name: "referral-email",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Email",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.referral.email) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.email]
            ])
          ]),
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _withDirectives(_createElementVNode("select", {
              id: "Referral_Agency_Branch",
              name: "agency-location-id",
              class: _normalizeClass(["form-select", `${!_ctx.v$.referral.locationId.$error ? '' : 'field-invalid'}`]),
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.referral.locationId) = $event)),
              onBlur: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.locationId.$touch && _ctx.v$.referral.locationId.$touch(...args)))
            }, [
              _hoisted_90,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: branch.id
                }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_91))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.locationId]
            ]),
            (_ctx.v$.referral.locationId.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Agency Branch is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "marital-status",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.referral.maritalStatus) = $event))
            }, [
              _hoisted_95,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MaritalStatuses, ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: key,
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_96))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.maritalStatus]
            ])
          ]),
          (_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                _hoisted_98,
                _withDirectives(_createElementVNode("select", {
                  id: "referral-ethnicity",
                  class: "form-select",
                  name: "ethnicityPalliative",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.referral.ethnicityOnly) = $event)),
                  disabled: _ctx.isEthnicityPalliativeDeclined,
                  onBlur: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.ethnicityOnly.$touch && _ctx.v$.referral.ethnicityOnly.$touch(...args)))
                }, [
                  _hoisted_100,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EthnicityPalliative, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: value.value
                    }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_101))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_99), [
                  [_vModelSelect, _ctx.referral.ethnicityOnly]
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input pb-1",
                    id: "decline-ethnicity",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.isEthnicityPalliativeDeclined) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.isEthnicityPalliativeDeclined]
                  ]),
                  _hoisted_103
                ]),
                (_ctx.v$.referral.ethnicityOnly.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_104, "Ethnicity is required."))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _hoisted_105,
          (_ctx.isHisSection)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
                  : (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _hoisted_110,
                      _createVNode(_component_TagsInput, {
                        class: "tags-wrapper-hos",
                        data: _ctx.RacesHospice,
                        tags: _ctx.selectedRacesHospice,
                        placeholder: "Select Race",
                        "aria-autocomplete": "off",
                        "open-on-focus": true,
                        onUpdateTags: _ctx.updateSelectedHospiceRaces,
                        onBlurredInput: _cache[34] || (_cache[34] = ($event: any) => (_ctx.v$.referral.race.$touch()))
                      }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags"]),
                      (_ctx.v$.referral.race.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Race is required."))
                        : _createCommentVNode("v-if", true)
                    ])),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
                  : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                      _hoisted_116,
                      _createVNode(_component_TagsInput, {
                        class: "tags-wrapper-hos",
                        data: _ctx.EthnicityHospice,
                        tags: _ctx.selectedEthnicityHospice,
                        placeholder: "Select Ethnicity",
                        "aria-autocomplete": "off",
                        "open-on-focus": true,
                        onUpdateTags: _ctx.updateSelectedHospiceEthnictiy,
                        onBlurredInput: _cache[35] || (_cache[35] = ($event: any) => (_ctx.v$.referral.hispanicEthnicityValues.$touch()))
                      }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags"]),
                      (_ctx.v$.referral.hispanicEthnicityValues.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_117, "Ethnicity is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                _hoisted_118,
                _createElementVNode("div", _hoisted_119, [
                  _hoisted_120,
                  _createVNode(_component_TagsInput, {
                    data: _ctx.RacesPalliative,
                    tags: _ctx.selectedRacesPalliative,
                    onUpdateTags: _ctx.updateSelectedRaces,
                    placeholder: "Select Race",
                    "aria-autocomplete": "off",
                    "open-on-focus": true,
                    disabled: _ctx.isRacesPalliativeDeclined
                  }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags", "disabled"]),
                  _createElementVNode("div", _hoisted_121, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input pb-1",
                      id: "decline-race",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isRacesPalliativeDeclined) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.isRacesPalliativeDeclined]
                    ]),
                    _hoisted_122
                  ])
                ]),
                _createElementVNode("div", _hoisted_123, [
                  _hoisted_124,
                  _createVNode(_component_TypeaheadInput, {
                    dropdownMenuClass: "granular-race-dropdown",
                    getData: _ctx.moreGranularRaceFilter,
                    value: _ctx.granularRace,
                    onValueChanged: _ctx.granularRaceChanged,
                    "show-all-by-default": true,
                    "open-on-focus": true,
                    "must-select-value": true,
                    placeholder: "Type to Filter Race",
                    closeOnOutsideClick: true,
                    disabled: _ctx.isRacesPalliativeDeclined
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _hoisted_126,
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "yesTribe",
                        name: "tribeIdentification",
                        class: "custom-control-input",
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.referral.isIdentifyWithTribe) = $event)),
                        value: true,
                        disabled: _ctx.hasDeclinedToIdentifyTribe
                      }, null, 8 /* PROPS */, _hoisted_129), [
                        [_vModelRadio, _ctx.referral.isIdentifyWithTribe]
                      ]),
                      _hoisted_130
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "noTribe",
                        name: "tribeIdentification",
                        class: "custom-control-input",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.referral.isIdentifyWithTribe) = $event)),
                        value: false,
                        disabled: _ctx.hasDeclinedToIdentifyTribe
                      }, null, 8 /* PROPS */, _hoisted_132), [
                        [_vModelRadio, _ctx.referral.isIdentifyWithTribe]
                      ]),
                      _hoisted_133
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input pb-1",
                      id: "decline-tribe",
                      checked: _ctx.referral.hasDeclinedToIdentifyTribe,
                      onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleDeclineChange($event.target.checked)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_135),
                    _hoisted_136
                  ])
                ]),
                (_ctx.referral.isIdentifyWithTribe === true && !_ctx.hasDeclinedToIdentifyTribe)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                      _hoisted_138,
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select", `${!_ctx.v$.referral.typeOfAffiliation.$error ? '' : 'field-invalid'}`]),
                        name: "tribal-affiliation",
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.referral.typeOfAffiliation) = $event)),
                        onBlur: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.typeOfAffiliation.$touch && _ctx.v$.referral.typeOfAffiliation.$touch(...args)))
                      }, [
                        _hoisted_139,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TribalAffiliation, ([key, value]) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: value.value
                          }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_140))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelSelect, _ctx.referral.typeOfAffiliation]
                      ]),
                      (_ctx.v$.referral.typeOfAffiliation.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_141, "Tribal Affiliation is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.referral.typeOfAffiliation == 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                      _hoisted_143,
                      _withDirectives(_createElementVNode("input", {
                        name: "referral-tribal-affiliation",
                        class: "form-control",
                        type: "text",
                        placeholder: "Enter Type of Affiliation",
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.referral.othertribalAffiliation) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.referral.othertribalAffiliation]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
                                _ctx.referral.isIdentifyWithTribe === true &&
                                !_ctx.hasDeclinedToIdentifyTribe &&
                                _ctx.referral.typeOfAffiliation > 0 &&
                                _ctx.referral.typeOfAffiliation < 4
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                      _hoisted_145,
                      _createVNode(_component_MultiSelectFilter, {
                        id: "client-tribe-list",
                        "on-fetch": _ctx.tribeNameFilter,
                        "selected-items": _ctx.tribeList,
                        onSelectedItemsUpdated: _ctx.tribeListChanged,
                        placeholder: "search tribe name",
                        customMessage: "Tribe Name"
                      }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */)),
          _hoisted_146,
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_147, _hoisted_149))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                _createVNode(_component_ReferralAddressForm, {
                  "address-type": "primaryAddress",
                  "facility-id": _ctx.referral.primaryAddressFacilityTypeId,
                  "onUpdate:facility-id": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.referral.primaryAddressFacilityTypeId) = $event)),
                  address: _ctx.referral.primaryAddress,
                  "onUpdate:address": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.referral.primaryAddress) = $event)),
                  application: _ctx.referral.application,
                  "account-id": _ctx.referral.accountId,
                  "show-code": _ctx.isHisSection,
                  "is-primary-address": true,
                  "reset-same-as-primary-address": _ctx.resetSameAsPrimaryAddress,
                  "is-address-validation-in-progress": _ctx.isAddressValidationInProgress,
                  "provider-id": _ctx.providerId
                }, null, 8 /* PROPS */, ["facility-id", "address", "application", "account-id", "show-code", "reset-same-as-primary-address", "is-address-validation-in-progress", "provider-id"]),
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    (!_ctx.referral.primaryAddress.latitude && !_ctx.referral.primaryAddress.longitude)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button fr ai-validate-btn",
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.validateAddress()))
                        }, " Validate Patient Primary Address "))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", null, [
                    (!_ctx.referral.primaryAddress.latitude && !_ctx.referral.primaryAddress.longitude)
                      ? (_openBlock(), _createElementBlock("h6", {
                          key: 0,
                          class: _normalizeClass(`${
                                        _ctx.referral.primaryAddress.isBypassed ? 'text-warning' : 'text-danger'
                                    } fw-bold`)
                        }, [
                          _hoisted_152,
                          _createElementVNode("span", null, " Address " + _toDisplayString(_ctx.referral.primaryAddress.isBypassed ? "Validation Bypassed" : "Not Validated"), 1 /* TEXT */)
                        ], 2 /* CLASS */))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_153, _hoisted_156))
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */)),
          _hoisted_157,
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_158, _hoisted_160))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                _createElementVNode("div", _hoisted_161, [
                  _createElementVNode("div", _hoisted_162, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "visit-same-primary-address",
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.visitAddrSameAsPrimaryAddr) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.visitAddrSameAsPrimaryAddr]
                    ]),
                    _hoisted_163
                  ])
                ]),
                (!_ctx.visitAddrSameAsPrimaryAddr)
                  ? (_openBlock(), _createBlock(_component_ReferralAddressForm, {
                      key: 0,
                      "address-type": "visitAddress",
                      address: _ctx.referral.visitAddress,
                      application: _ctx.referral.application,
                      "account-id": _ctx.referral.accountId,
                      "facility-id": _ctx.referral.visitAddressFacilityTypeId,
                      "provider-id": _ctx.providerId
                    }, null, 8 /* PROPS */, ["address", "application", "account-id", "facility-id", "provider-id"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */)),
          _hoisted_164,
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_165, _hoisted_167))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                _createElementVNode("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "mailing-same-primary-address",
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.mailingAddrSameAsPrimaryAddr) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.mailingAddrSameAsPrimaryAddr]
                    ]),
                    _hoisted_170
                  ])
                ]),
                (!_ctx.mailingAddrSameAsPrimaryAddr)
                  ? (_openBlock(), _createBlock(_component_ReferralAddressForm, {
                      key: 0,
                      "address-type": "mailingAddress",
                      address: _ctx.referral.mailingAddress,
                      application: _ctx.referral.application,
                      "account-id": _ctx.referral.accountId,
                      "facility-id": _ctx.referral.mailingAddressFacilityTypeId,
                      "provider-id": _ctx.providerId
                    }, null, 8 /* PROPS */, ["address", "application", "account-id", "facility-id", "provider-id"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */)),
          (_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                _hoisted_171,
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, _hoisted_174))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_175, [
                        _createElementVNode("div", _hoisted_176, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "previous-same-primary-address",
                            class: "form-check-input au-target",
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.referral.hasPreviousAddress) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.referral.hasPreviousAddress]
                          ]),
                          _hoisted_177
                        ])
                      ]),
                      (_ctx.referral.hasPreviousAddress)
                        ? (_openBlock(), _createBlock(_component_ReferralAddressForm, {
                            key: 0,
                            "address-type": "previousAddress",
                            address: _ctx.referral.previousAddress,
                            application: _ctx.referral.application,
                            "account-id": _ctx.referral.accountId,
                            "facility-id": _ctx.referral.previousAddressFacilityTypeId,
                            "provider-id": _ctx.providerId,
                            "show-move-date": true
                          }, null, 8 /* PROPS */, ["address", "application", "account-id", "facility-id", "provider-id"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_178, [
        _createElementVNode("div", _hoisted_179, [
          _hoisted_180,
          _withDirectives(_createElementVNode("select", {
            id: "Referral_Cahps",
            class: "form-select",
            name: "referral-Cahps",
            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.referral.cahpsSurveyContactType) = $event))
          }, _hoisted_183, 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.referral.cahpsSurveyContactType]
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "languages"),
      _renderSlot(_ctx.$slots, "tags")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["type", "application-id"]))
}